import {
    Checkbox, DetailsListLayoutMode, IColumn, IObjectWithKey, ISelection, SelectionMode,
} from '@fluentui/react';
import { useState } from 'react';
import { DetailsListDefault } from '../../../components/parts';
import { IArchitect } from '../../../utils';
import { ICar } from '../../../utils/Car';
import { formatPhoneNumber } from '../../../helpers';

interface props {
    items: IArchitect[],
    selection?: ISelection<IObjectWithKey> | undefined,
    onItemInvoked?: () => void;
    enableShimmer?: boolean;
    isSortedAsc?: boolean;
    sortedField: string;
    setSorting: (isDesc: boolean, field: string) => void;
    loadMore?: boolean;
    lazyLoading?: boolean;
    loading?: boolean;
    loadMoreCallback?: () => void;
}

const ArchitectsDetailsList = ({
    items,
    selection,
    onItemInvoked,
    enableShimmer = false,
    isSortedAsc = false,
    sortedField,
    setSorting, // = (isSortedAsc: boolean, sortedField: string) => {},
    loadMore,
    lazyLoading,
    loading,
    loadMoreCallback,
  }: props) => {
    // On Column Click
    const onColumnClick = (event: any, column: any) => {
        const sortedColumn = columns.filter((col: IColumn) => col.isSorted);
        let fieldName = '';
        let sortDescending = false;

        if (sortedColumn) {
          const newColumns = columns.map((col: IColumn) => {
            if (col.fieldName === column.fieldName) {
              col.isSorted = true;

              col.isSortedDescending =
                column.fieldName !== sortedColumn[0].fieldName
                  ? false
                  : !col.isSortedDescending;

              fieldName = column.fieldName;
              sortDescending = col.isSortedDescending;
            } else {
              col.isSorted = false;
            }
            return col;
          });
          setColumns(newColumns);

          setSorting(!sortDescending, fieldName);
        }
      };

    // Column List
    const columnsList = [
        {
          key: 'column1',
          name: 'Naam',
          fieldName: 'last_name',
          minWidth: 100,
          maxWidth: 100,
          isRowHeader: true,
          onRender: (architect: IArchitect) => <span>{architect.last_name}</span>,
          onColumnClick,
          data: 'string',
          isPadded: true,
        },
        {
          key: 'column2',
          name: 'Voornaam',
          fieldName: 'first_name',
          minWidth: 100,
          maxWidth: 100,
          isRowHeader: true,
          onRender: (architect: IArchitect) => <span>{architect.first_name}</span>,
          onColumnClick,
          data: 'string',
          isPadded: true,
        },
        {
          key: 'column3',
          name: 'Bedrijf',
          fieldName: 'company',
          minWidth: 250,
          maxWidth: 250,
          isRowHeader: true,
          onRender: (architect: IArchitect) => <span>{architect.company}</span>,
          onColumnClick,
          data: 'string',
          isPadded: true,
        },
        {
          key: 'column4',
          name: 'Stad/Gemeente',
          fieldName: 'city',
          minWidth: 150,
          maxWidth: 150,
          isRowHeader: true,
          onRender: (architect: IArchitect) => <span>{architect.city}</span>,
          data: 'string',
          isPadded: true,
        },
        {
          key: 'column5',
          name: 'E-mail',
          fieldName: 'email',
          minWidth: 250,
          maxWidth: 600,
          isRowHeader: true,
          onRender: (architect: IArchitect) => <span>{architect.email}</span>,
          data: 'string',
          isPadded: true,
        },
        {
          key: 'column6',
          name: 'GSM',
          fieldName: 'mobile',
          minWidth: 100,
          maxWidth: 100,
          isRowHeader: true,
          onRender: (architect: IArchitect) => <span>{architect.mobile_v2 ? formatPhoneNumber(architect.mobile_v2) : ''}</span>,
          data: 'string',
          isPadded: true,
        },
      ];

    const initColumns = (sortedField: string, isSortedAsc: boolean) => columnsList.map((column: IColumn) => {
      if (column.fieldName === sortedField) {
        column.isSorted = true;
        column.isSortedDescending = !isSortedAsc;
        return column;
      }
      return column;
    });

    const [columns, setColumns] = useState(initColumns(sortedField, isSortedAsc));

    return (
      <DetailsListDefault
        items={items}
        columns={columns}
        layoutMode={DetailsListLayoutMode.justified}
        selection={selection}
        selectionMode={SelectionMode.single}
        selectionPreservedOnEmptyClick
        onItemInvoked={onItemInvoked}
        enableShimmer={enableShimmer}
        loadMore={loadMore}
        lazyLoading={lazyLoading}
        loadMoreCallback={loadMoreCallback}
        loading={loading}
      />
    );
  };

  export default ArchitectsDetailsList;
